function smsHistoryHaystack(row = {}) {
  const parts = [
    row.createdAt,
    row.direction,
    row.phoneDigits,
    row.status,
    row.templateKey,
    row.twilioSid,
    row.body,
  ];
  if (Array.isArray(row.media) && row.media.length) parts.push('photo');
  return parts
    .filter((part) => part != null && part !== '')
    .join(' ')
    .toLowerCase();
}

function smsHistoryLine(row = {}) {
  const body = String(row.body || '').trim();
  if (body) return body.slice(0, 80);
  if (Array.isArray(row.media) && row.media.length) return 'Photo';
  return '';
}

function filterSmsHistory(rows, query) {
  const list = Array.isArray(rows) ? rows : [];
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return list;
  return list.filter((row) => smsHistoryHaystack(row).includes(needle));
}

module.exports = {
  filterSmsHistory,
  smsHistoryHaystack,
  smsHistoryLine,
};
